import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MasterAdminLayout from './MasterAdminLayout';
import MasterAdminDashboard from './MasterAdminDashboard';
import SuperAdminManagement from './SuperAdminManagement';
import SubscriptionsManagement from './SubscriptionsManagement';
import PlanManagement from './PlanManagement';
import ContactsManagement from './ContactsManagement';
import BugReportsManagement from './BugReportsManagement';
import EmailSettings from './EmailSettings';

const MasterAdminRoutes = () => {
  const { user } = useAuth();

  if (!user || user.role !== 'master-admin') {
    return <Navigate to="/login" />;
  }

  return (
    <MasterAdminLayout>
      <Routes>
        <Route index                  element={<MasterAdminDashboard />} />
        <Route path="super-admins"    element={<SuperAdminManagement />} />
        <Route path="subscriptions"   element={<SubscriptionsManagement />} />
        <Route path="plans"           element={<PlanManagement />} />
        <Route path="contacts"        element={<ContactsManagement />} />
        <Route path="bug-reports"     element={<BugReportsManagement />} />
        <Route path="email-settings"  element={<EmailSettings />} />
        <Route path="settings"        element={<div style={{ padding: '24px', color: '#94a3b8' }}><h1>System Settings</h1><p>Coming soon...</p></div>} />
      </Routes>
    </MasterAdminLayout>
  );
};

export default MasterAdminRoutes;
